import { Component, Renderer2, ElementRef, AfterViewInit, ViewChild } from '@angular/core';
import { AuthService } from '../auth.service';
import { Router, NavigationEnd, RouterEvent } from '@angular/router';

@Component({
  selector: 'app-login',
  template: `
    <div class="login-container">
      <h1>Perterter Drawing Moderator Portal</h1>
      <button #loginButton class="login-twitch-button" (click)="login()">
        <img src="twitch-logo.svg" alt="Twitch Logo" class="twitch-logo" />
        Login with Twitch
      </button>
    </div>
  `,
  styles: [`
    .login-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100vh;
      background-color: var(--background-color);
      color: var(--text-color);
    }
    .login-twitch-button {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #9146FF; /* Twitch purple */
      color: white;
      border: none;
      padding: 10px 16px;
      border-radius: 4px;
      cursor: pointer;
      font-size: 16px;
      font-weight: bold;
      transition: background-color 0.3s ease;
    }
    .login-twitch-button:hover {
      background-color: #772ce8; /* Darker Twitch purple */
    }
    .twitch-logo {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
    .flash {
      animation: flash-animation 0.5s ease-in-out 3; /* Flicker 3 times faster */
    }
    @keyframes flash-animation {
      0%, 100% { background-color: #9146FF; color: white; }
      25%, 75% { background-color: #772ce8; color: white; }
      50% { background-color: rgb(238, 255, 0); color: black; } /* Add a bright flash in the middle */
    }
  `]
})
export class LoginComponent implements AfterViewInit {
  @ViewChild('loginButton') loginButton!: ElementRef;

  constructor(
    private authService: AuthService,
    private router: Router,
    private renderer: Renderer2
  ) {}

  ngAfterViewInit(): void {
    this.router.events.subscribe(event => {
      if (event instanceof RouterEvent && event.url === '/login') {
        if (this.loginButton) {
          this.renderer.addClass(this.loginButton.nativeElement, 'flash');
          setTimeout(() => this.renderer.removeClass(this.loginButton.nativeElement, 'flash'), 1500); // Match animation duration
        }
      }
    });
  }

  login(): void {
    this.authService.login();
  }
}
